import { render, staticRenderFns } from "./LogoSpinner.vue?vue&type=template&id=5034e68b&scoped=true"
import script from "./LogoSpinner.vue?vue&type=script&setup=true&lang=js"
export * from "./LogoSpinner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LogoSpinner.vue?vue&type=style&index=0&id=5034e68b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5034e68b",
  null
  
)

export default component.exports